import { Users, DollarSign, CreditCard, Circle, Building2, Calendar, CirclePlus, FileText, ClipboardList } from 'lucide-react';

const ClubManagementPreview = () => {
  const stats = [
    { icon: Users, value: '104', label: 'Total Players', subtitle: 'Across 6 programs' },
    { icon: DollarSign, value: '$0.00', label: 'Revenue (30d)', subtitle: 'Net: $0.00', isNegative: true },
    { icon: CreditCard, value: '0', label: 'Active Subscriptions', subtitle: '0%' },
    { icon: Circle, value: '6', label: 'Programs', subtitle: 'Active programs' }
  ];

  const quickActions = [
    { icon: Building2, label: 'My Club' },
    { icon: Calendar, label: 'Schedule Match' },
    { icon: CirclePlus, label: 'Create Program' },
    { icon: FileText, label: 'View Reports' },
    { icon: ClipboardList, label: 'Manage Applications' }
  ];

  return (
    <div className="w-full max-w-[600px] bg-card rounded-2xl border border-border shadow-premium-xl overflow-hidden">
      {/* Header */}
      <div className="p-3 sm:p-4 border-b border-border bg-muted/30">
        <h2 className="font-bold text-foreground text-base sm:text-lg">Club Owner Dashboard</h2>
        <p className="text-xs sm:text-sm text-muted-foreground">Managing Dreams Football Academy</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3 p-3 sm:p-4">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="bg-muted/30 rounded-xl p-2.5 sm:p-3 border border-border/50 relative">
              <Icon className="absolute top-2 right-2 w-3.5 h-3.5 sm:w-4 sm:h-4 text-muted-foreground/50" />
              <p className="text-lg sm:text-2xl font-bold text-foreground">{stat.value}</p>
              <p className="text-[10px] sm:text-xs text-muted-foreground font-medium">{stat.label}</p>
              <p className={`text-[10px] sm:text-xs mt-0.5 ${stat.isNegative ? 'text-rose-400' : 'text-muted-foreground'}`}>
                {stat.subtitle}
              </p>
            </div>
          );
        })}
      </div>

      {/* Quick Actions */}
      <div className="px-3 sm:px-4 pb-3 sm:pb-4">
        <h3 className="text-xs sm:text-sm font-semibold text-muted-foreground mb-2 sm:mb-3">Quick Actions</h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
          {quickActions.slice(0, 4).map((action, index) => {
            const Icon = action.icon;
            return (
              <button
                key={index}
                className="flex flex-col items-center gap-1.5 sm:gap-2 p-2.5 sm:p-3 rounded-xl bg-muted/30 border border-border/50 hover:bg-muted/50 transition-colors"
              >
                <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-muted-foreground" />
                <span className="text-[10px] sm:text-xs text-foreground font-medium text-center leading-tight">{action.label}</span>
              </button>
            );
          })}
        </div>
        {/* Fifth action centered below */}
        <div className="flex justify-center mt-2">
          <button className="flex flex-col items-center gap-1.5 sm:gap-2 p-2.5 sm:p-3 rounded-xl bg-muted/30 border border-border/50 hover:bg-muted/50 transition-colors w-full sm:w-auto sm:min-w-[140px]">
            <ClipboardList className="w-4 h-4 sm:w-5 sm:h-5 text-muted-foreground" />
            <span className="text-[10px] sm:text-xs text-foreground font-medium text-center leading-tight">Manage Applications</span>
          </button>
        </div>
      </div>

      {/* Upcoming Matches */}
      <div className="px-3 sm:px-4 pb-3 sm:pb-4">
        <h3 className="text-xs sm:text-sm font-semibold text-muted-foreground mb-2 sm:mb-3">Upcoming Matches</h3>
        <div className="bg-muted/30 rounded-xl p-3 sm:p-4 border border-border/50 text-center">
          <p className="text-xs sm:text-sm text-muted-foreground">No upcoming matches</p>
        </div>
      </div>
    </div>
  );
};

export default ClubManagementPreview;
